export const parseSpecificsErrors = (
  errors = {
    ebayListingCategoryMarketCategory: undefined,
    ebaySpecifics: undefined
  }
) => {
  if (errors.ebaySpecifics) {
    return `Specifics error: ${errors.ebaySpecifics}`
  }

  if (errors.ebayListingCategoryMarketCategory) {
    return `Category ${errors.ebayListingCategoryMarketCategory}`
  }

  return 'Something went wrong when refreshing specifics. Please click "Refresh" to try again.'
}
